import { ArrowRight } from "lucide-react";

interface StoreButtonProps {
	href: string;
	label: string;
	variant: "primary" | "secondary" | "coral";
}

export function StoreButton({ href, label, variant }: StoreButtonProps) {
	const baseClassName =
		"inline-flex items-center justify-center gap-3 rounded-full px-6 py-3.5 text-sm font-semibold tracking-[-0.02em] transition-transform duration-200 hover:-translate-y-0.5";
	const variantClassName =
		variant === "primary"
			? "bg-[linear-gradient(135deg,var(--color-app-accent),var(--color-app-accent-secondary))] text-white shadow-[0_22px_40px_-24px_rgba(255,90,95,0.72)]"
			: variant === "coral"
				? "border border-white/10 bg-[linear-gradient(180deg,rgba(255,90,95,0.92),rgba(255,154,90,0.9))] text-white shadow-[0_24px_64px_-38px_rgba(255,90,95,0.72)]"
				: "border border-white/12 bg-white/6 text-white shadow-[0_18px_38px_-28px_rgba(0,0,0,0.4)] backdrop-blur";

	return (
		<a href={href} target="_blank" rel="noreferrer" className={`${baseClassName} ${variantClassName}`}>
			<span>{label}</span>
			<ArrowRight className="size-4" />
		</a>
	);
}
